<template>
  <div>
    <b-container id="form" fluid>
      <b-row class="px-3">
        <b-col cols="auto" class="my-1 px-1px">
          <!--          <datepicker-->
          <!--                  :minimum-view="'day'"-->
          <!--                  format="d/MM/yyyy"-->
          <!--                  v-model="filter.dateOne"-->
          <!--                  input-class="date-box"-->
          <!--                  clear-button-->
          <!--                  @input="filters(filter)"></datepicker>-->
          <div
            class="datepicker-trigger input-group"
            style="min-width: 150px;"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <label for="datepicker-trigger" />
            <input
              id="datepicker-trigger"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(filter.dateOne, filter.dateTwo)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
              >
                <fa-icon
                  :style="{
                    opacity: activeCloseDate ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne"
              :date-two="filter.dateTwo"
              @date-one-selected="
                (val) => {
                  filter.dateOne = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo = val;
                }
              "
            />
          </div>
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <multiselect
            v-model="filter.direction"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="direction"
            label="direction"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="เส้นทางวิ่ง"
          />
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <multiselect
            v-model="filter.hospital"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="hospital"
            label="name"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="สถานพยาบาล"
          />
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <multiselect
            v-model="filter.species"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="species"
            label="species_name"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="Species"
          />
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <multiselect
            v-model="filter.gender"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="genders"
            label="gender_name"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="Gender"
          />
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <label>
            <input
              v-model="filter.owner_name"
              type="search"
              class="form-control"
              placeholder="ชื่อเจ้าของ"
              style="min-width: 150px;"
            />
          </label>
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <label>
            <input
              v-model="filter.hn"
              type="search"
              class="form-control"
              placeholder="HN"
              style="min-width: 150px;"
            />
          </label>
        </b-col>
        <b-col cols="auto" class="my-1 px-1px">
          <label>
            <input
              v-model="filter.pet_name"
              type="search"
              class="form-control"
              placeholder="ชื่อสัตว์"
              style="min-width: 150px;"
            />
          </label>
        </b-col>
        <b-col cols="auto" class="my-auto">
          <b-button
            variant="link"
            block
            class="search-icon"
            @click="filters(filter)"
          >
            <fa-icon icon="search" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-table :fields="fields" :items="items.data" striped bordered responsive>
      <!-- A virtual column -->
      <template slot="-" slot-scope="data">
        <label class="check-box">
          <input id="exampleCheck1" type="checkbox" :value="data.item.id" />
          <span class="checkmark" />
        </label>
      </template>
      <template slot="no" slot-scope="data">
        <div class="col-right">{{ data.index + items.from }}</div>
      </template>
      <template slot="ชื่อสัตว์" slot-scope="data">
        <div class="col-left">
          <a @click="goAnimalPage(data.item.id, data.item.hospital_id)">
            <u>{{ data.item.name }}</u>
          </a>
        </div>
      </template>
      <template slot="ชื่อสถานพยาบาล" slot-scope="data">
        <div class="col-left">
          <a @click="goHospitalPage(data.item.hospital_id)">
            <u>{{ data.item.hospital_name }}</u>
          </a>
        </div>
      </template>
      <template slot="species" slot-scope="data">
        <div class="col-left">
          {{
            data.item.species
              ? data.item.species.species_name === "อื่นๆ"
                ? data.item.other_specie
                : data.item.species.species_name
              : ""
          }}
        </div>
      </template>
      <template slot="ชื่อเจ้าของ" slot-scope="data">
        <div class="col-left">
          {{ data.item.owner_name }}
        </div>
      </template>
      <template slot="วันเวลาอัพเดทล่าสุด" slot-scope="data">
        <div class="col-center">{{ moment(data.item.updated_at) }}</div>
      </template>
      <template slot="gender.gender_name" slot-scope="data">
        <div class="col-left">{{ data.item.gender.gender_name }}</div>
      </template>
      <template slot="an" slot-scope="data">
        <div class="col-right">{{ data.item.an }}</div>
      </template>
      <template slot="hn" slot-scope="data">
        <div class="col-right">{{ data.item.hn }}</div>
      </template>
      <template slot="คำสั่งตรวจ" slot-scope="data">
        <div>
          <button
            type="button"
            class="btn btn-primary"
            @click="goAnimalPage(data.item.id, data.item.hospital_id)"
          >
            คำสั่งตรวจ
          </button>
        </div>
      </template>
      <template slot="action" slot-scope="data">
        <b-button
          block
          size="sm"
          @click="copyAnimalHandler(data.item.id, data.item.hospital_id)"
          >คัดลอก</b-button
        >
        <b-button
          block
          class="btn-danger"
          size="sm"
          @click="deleteAnimalHandler(data.item.id)"
          >ลบ</b-button
        >
      </template>
      <!-- <template slot="ข้อมูลการตรวจ" slot-scope="data">
                <button type="button" class="btn btn-primary">
                    ข้อมูลการตรวจ
                </button>
      </template>-->
    </b-table>
    <div v-if="items.data ? items.data.length <= 0 : true">ไม่พบข้อมูล</div>
    <b-pagination
      v-model="items.current_page"
      size="md"
      :total-rows="items.total"
      :per-page="items.per_page"
      @input="getDataPerPage(items.current_page)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    // Datepicker
  },
  data() {
    return {
      activeCloseDate: false,
      fields: [
        // "-",
        "no",
        // A column that needs custom formatting
        { key: "an", label: "AN" },
        // A regular column
        "ชื่อสัตว์",
        // A regular column
        "ชื่อสถานพยาบาล",
        { key: "hn", label: "HN" },
        { key: "species", label: "Species" },
        "ชื่อเจ้าของ",
        // A virtual column made up from two fields
        { key: "gender.gender_name", label: "Gender" },
        "วันเวลาอัพเดทล่าสุด",
        "คำสั่งตรวจ",
        { key: "action", label: "ACTION" },
        // "ข้อมูลการตรวจ"
      ],
      dateFormat: "D/MM/YYYY",
    };
  },
  created() {
    // this.$store.state.isLoading = true;
    const res = {
      page_no: this.filter.page_no,
      direction_id: this.filter.direction,
      hospital_id: this.filter.hospital ? this.filter.hospital.id : null,
      species_id: this.filter.species_id,
      gender_id: this.filter.gender,
      owner_name: this.filter.owner_name,
      pet_name: this.filter.pet_name,
      hn: this.filter.hn,
      start_date: this.filter.dateOne,
      end_date: this.filter.dateTwo,
    };
    // var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    // this.filter.dateOne = today;
    // this.filterAnimal(res);
    this.$nextTick((val) => {
      // this.filterAnimal(res).then(() => {
      //   this.$store.state.isLoading = false;
      // });
    });
  },
  // watch: {
  //     "filter.startDate"() {
  //         this.filters(this.filter);
  //     },
  //     "filter.endDate"() {
  //         this.filters(this.filter);
  //     }
  // },
  computed: {
    ...mapGetters({
      items: "Animal/getDataFromFilter",
      direction: "Direction/getAll",
      hospital: "Hospital/getAll",
      species: "Species/getAll",
      genders: "Gender/getAll",
      getFilter: "Animal/getFilter",
    }),
    filter: {
      get() {
        return this.getFilter;
      },
      set(value) {
        this.setFilter(value);
      },
    },
  },
  methods: {
    ...mapActions({
      getAllAnimal: "Animal/getAll",
      filterAnimal: "Animal/filterData",
      setAnimalData: "Animal/setData",
      setCustomerData: "Hospital/setData",
      setAdding: "History/setAdding",
      deleteAnimal: "Animal/deleteAnimal",
      setFilter: "Animal/setFilter",
      removeAnimalId: "Animal/removeAnimalId",
      genAN: "Animal/genAN",
    }),
    async goHospitalPage(hospitalId) {
      this.$store.state.isLoading = true;
      try {
        await this.setCustomerData(hospitalId);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;
      this.goHistoryCustomerAdding();
    },
    async goAnimalPage(id, hospitalId) {
      this.$store.state.isLoading = true;
      try {
        await this.setAnimalData(id);
        await this.setCustomerData(hospitalId);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;

      this.goHistoryAnimalAdding();
    },
    setSpecies(id) {
      // this.species.forEach(element => {
      //     if (element.id == id) {
      //         console.log(element.species_name);
      //         return element.species_name;
      //         // console.log(element);
      //     }
      // });
      for (let key in this.species) {
        if (this.species[key].id == id) {
          return this.species[key].species_name;
        }
      }
    },
    async goHistoryAnimalAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-animal-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-animal-adding" });
    },
    goHistoryCustomerAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-customer-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-customer-adding" });
    },
    moment(date) {
      return moment(date)
        .tz("Asia/Bangkok")
        .format("DD-MM-YYYY  h:mm:ss");
    },
    goOrder() {
      this.$router.push({ name: "history-order" });
    },
    async filters(obj) {
      this.$store.state.isLoading = true;
      let val = {};
      if (obj.dateTwo == "") {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          species_id: obj.species != null ? obj.species.id : "",
          gender_id: obj.gender != null ? obj.gender.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
        };
      } else {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          species_id: obj.species != null ? obj.species.id : "",
          gender_id: obj.gender != null ? obj.gender.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
        };
      }
      await this.filterAnimal(val);
      this.$store.state.isLoading = false;
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },
    async getDataPerPage(pageNo) {
      if (pageNo == null) return;
      this.$store.state.isLoading = true;
      this.filter.page_no = pageNo;
      await this.filters(this.filter);
      this.$store.state.isLoading = false;
    },
    deleteAnimalHandler(id) {
      this.$swal
        .fire({
          title: "กรอกรหัสผ่านยืนยันการลบ",
          input: "password",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "ลบ",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
          preConfirm: (password) => {
            return this.deleteAnimal({ id, payload: { password } })
              .then((res) => {
                if (!res) {
                  this.$swal.showValidationMessage(`รหัสผ่านไม่ถูกต้อง`);
                }
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        })
        .then((result) => {
          if (result.value) {
            const res = {
              page_no: this.filter.page_no,
              direction_id: this.filter.direction,
              hospital_id: this.filter.hospital,
              species_id: this.filter.species_id,
              gender_id: this.filter.gender,
              owner_name: this.filter.owner_name,
              pet_name: this.filter.pet_name,
              hn: this.filter.hn,
              start_date: this.filter.dateOne,
              end_date: this.filter.dateTwo,
            };
            this.$nextTick((val) => {
              this.filterAnimal(res);
              this.getAllAnimal();
              this.$swal.fire("เสร็จสิ้น", "ลบสัตว์เรียบร้อย", "success");
            });
          }
        });
    },
    async copyAnimalHandler(id) {
      this.$store.state.isLoading = true;
      try {
        await this.setAnimalData(id);
        await this.setAdding({ addingAnimal: true, addingCustomer: true });
        this.removeAnimalId();
        await this.genAN();
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        // this.$store.state.isLoading = false;
      }
      this.$store.state.isLoading = false;
      let routeData = this.$router.resolve({ name: "history-animal-adding" });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center; */
  /* height: 50px; */
  /* padding: 0.5rem; */
}
.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.select-box {
  margin: 0px 5px 0px 5px;
  /* width: 20vw; */
  padding-left: 0px;
}
.search-icon {
  /* align-self: center;
  margin: 0px 0px 0px 10px;
  cursor: pointer; */
  color: black;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
input[type="search"] {
  margin-left: 5px;
  /* /* width: 22%; */
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.datepicker-trigger {
  display: flex;
}
.icon {
  cursor: pointer;
}
.border-right-0 {
  padding-right: 0px;
}
</style>
